module.exports = __webpack_public_path__ + "img/i-cards-mono.ffa873d7.svg";